import {Injectable} from '@angular/core';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/delay';
import {Actions, Effect} from '@ngrx/effects';

import * as productActions from './../actions/products.actions';
import {Observable} from 'rxjs/Observable';
import {ProductService} from '../shared/product.service';

@Injectable()
export class ProductEffects {

  constructor(
    private productService: ProductService,
    private actions$: Actions
  ) { }

  @Effect()
  loadProducts$: Observable<productActions.ProductAction> = this.actions$
    .ofType(productActions.LOAD_PRODUCTS)
    .switchMap(() => {
        return this.productService.getProdcutsFromBackend()
          .map( products => new productActions.LoadProductsSuccessAction(products));
      }
    );
}



// WEBPACK FOOTER //
// C:/Users/majli/reposales365/sale365/src/app/effects/product.effects.ts